module.exports = __webpack_public_path__ + "img/eatonbanner.cd2a6aa0.png";